import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as routing from '../../../_model/routing';

import { MeetingsService } from 'src/app/_service/meetings.service';
import { AuthService } from 'src/app/_service/auth.service';

import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-join',
  templateUrl: './join.component.html',
  styleUrl: './join.component.css'
})
export class JoinComponent implements OnDestroy {
  inMeeting = false;
  roomName = '';
	token!: string;
	isSessionAlive = false;
	serverError = '';
	loading = true;
  roomForm: FormGroup;
  constructor(
    private meetingsService: MeetingsService,
    private auth: AuthService,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
  ) {
    const name = this.route.snapshot.queryParamMap.get('roomName');
    this.roomForm = new FormGroup({
      roomName: name !== null ? new FormControl(name) : new FormControl('Meeting with ' + this.auth.userName, Validators.required),
      participantName: new FormControl(this.auth.userName, Validators.required),
    });
    if (name !== null) this.joinRoom();
  }

  onRoomDisconnected() {
    this.inMeeting = false;
		this.isSessionAlive = false;
	}

  async joinRoom() {
    this.inMeeting = true;
    this.meetingsService.roomName = this.roomForm.value.roomName!.replaceAll(" ", "-");
    this.router.navigate([routing.Room + "/" + this.meetingsService.roomName]);
  }

  goBack() {
    this.location.back();
  }


  @HostListener('window:beforeunload')
  async ngOnDestroy() {
    // On window closed or component destroyed, leave the room
    this.onRoomDisconnected();
  }
}
